<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите меру" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzDisabled]="!op.enabled" [nzLabel]="(op.title | uiLabel) + ' (' + (op.globalShortTitle | uiLabel) + ')'" [nzValue]="op.id"></nz-option>
</nz-select>
